module.exports = __webpack_public_path__ + "img/ioniq6-25.1ca115ab.png";